import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import IssueRequiredField, { issueRequiredFieldLabel, } from '@opsbase/lib-issue/IssueRequiredField/IssueRequiredField';
import Pages from '@opsbase/lib-pages';
import { Palette } from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useOrgUpdate from '@opsbase/react-gql-hooks/organisation/useOrgUpdate';
import useCallforward from '@opsbase/react-hooks/useCallforward/useCallforward';
import markdown from '@opsbase/react-markdown';
import AppPage from '@opsbase/web-app/AppPage';
import EditableList from '@opsbase/web-editablelist';
import InfoIcon from '@opsbase/web-icons/icons/InfoIcon';
import Card from '@opsbase/web-layout/Card/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import IconButton from '@opsbase/web-ui/IconButton/IconButton';
import NonModalPopover from '@opsbase/web-ui/NonModalPopover';
import Spinner from '@opsbase/web-ui/Spinner';
import Switch from '@opsbase/web-ui/Switch/Switch';
import Text from '@opsbase/web-ui/Text';
import debounce from 'lodash/debounce';
import React, { useCallback, useMemo, useState } from 'react';
export function AdvancedIssueTypesPage() {
    var _a, _b;
    const self = useSelf();
    const { updateSettings } = useSelfActions();
    const { goTo } = useNav();
    const [rPopoverAncor, setRPopoverAncor] = useState();
    const [rPopoverIssueType, setRPopoverIssueType] = useState();
    const { loading, data: org } = useOrgFindById({ variables: { id: self.organisationId } });
    const updateOrg = useOrgUpdate();
    // useEffect(() => {
    // 	if (issueTypes === org?.settings?.issueTypes) return
    // 	setIssueTypes(org?.settings?.issueTypes)
    // }, [issueTypes, org?.settings?.issueTypes])
    const doChange = useMemo(() => debounce((org, updateOrg, updateSettings, newIssueTypes) => {
        const patch = {
            issueTypes: newIssueTypes,
        };
        updateOrg({
            id: org.id,
            patch: {
                settings: {
                    ...patch,
                },
            },
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateOrg: {
                    __typename: 'Organisation',
                    ...org,
                    ...{ settings: { ...org.settings, ...patch } },
                },
            },
        })
            .then(updatedOrg => {
            updateSettings(updatedOrg.settings);
        })
            .catch(doNothing);
    }, 500, { leading: false, trailing: true }), []);
    const issueTypes = (_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.issueTypes;
    // We will ignore the unspecified one and add it back in before saving the change
    const issueTypesWithoutUnspecified = useMemo(() => issueTypes === null || issueTypes === void 0 ? void 0 : issueTypes.filter(z => z.key !== 'unspecified'), [issueTypes]);
    const unspecifiedIssueType = useMemo(() => issueTypes === null || issueTypes === void 0 ? void 0 : issueTypes.find(z => z.key === 'unspecified'), [issueTypes]);
    const handleChange = useCallback(newIssueTypes => {
        doChange(org, updateOrg, updateSettings, [...newIssueTypes, unspecifiedIssueType]);
    }, [doChange, org, updateOrg, updateSettings, unspecifiedIssueType]);
    const handleDelete = useCallback(issueType => {
        goTo(Pages.ISSUE_TYPE_DELETE, { type: issueType.key });
    }, [goTo]);
    const handleOpenPopover = useCallforward((issueType, inputRef) => () => {
        setRPopoverIssueType(issueType);
        setRPopoverAncor(inputRef);
    }, []);
    const handleClosePopover = useCallback(() => setRPopoverAncor(undefined), []);
    const handleChangeRequired = useCallback(v => {
        var _a;
        rPopoverIssueType.requirements = v;
        handleChange((_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.issueTypes);
    }, [handleChange, (_b = org === null || org === void 0 ? void 0 : org.settings) === null || _b === void 0 ? void 0 : _b.issueTypes, rPopoverIssueType]);
    const renderAfterItem = useCallback((issueType, _, inputRef) => {
        const selected = !!rPopoverAncor && rPopoverAncor === inputRef;
        return (React.createElement(Horizontal, { gutter: true, justify: "flex-end" },
            React.createElement(IconButton, { icon: React.createElement(InfoIcon, { color: selected ? Palette.GoodOldBlue : undefined }), onMouseEnter: handleOpenPopover(issueType, inputRef) })));
    }, [handleOpenPopover, rPopoverAncor]);
    return (React.createElement(AppPage, null,
        React.createElement(Spinner, { busy: loading }, () => {
            var _a;
            return (React.createElement(Vertical, { padding: true, style: { overflow: 'auto' } },
                React.createElement(Pane, { padding: true },
                    React.createElement(Text, { variant: "h2" }, markdown(i18n.t('issue-group-question'))),
                    ((_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.issueTypes) && (React.createElement("div", { style: { width: 500 } },
                        React.createElement(EditableList, { autoSelectIdx: 0, placeholder: i18n.t('enter-name-of-new-issue-type'), items: issueTypesWithoutUnspecified, idField: "key", valueField: "title", afterItem: renderAfterItem, canAddInline: true, canAddAtBottom: true, canDelete: true, canReorder: true, onDelete: handleDelete, onChange: handleChange })))),
                React.createElement(NonModalPopover, { open: !!rPopoverAncor, onClose: handleClosePopover, onMouseLeave: handleClosePopover, anchorEl: rPopoverAncor, placement: "right-start" }, rPopoverIssueType && (React.createElement(Vertical, { padding: true, style: { overflow: 'auto', maxWidth: 300 } },
                    React.createElement(Pane, { padding: true },
                        React.createElement(Text, null, i18n.t('issue-requirements-desc'))),
                    React.createElement(Card, null,
                        React.createElement(Vertical, { gutter: true, padding: true },
                            React.createElement(FieldSwitch, { issueType: rPopoverIssueType, field: IssueRequiredField.CAUSES, onChange: handleChangeRequired }),
                            React.createElement(FieldSwitch, { issueType: rPopoverIssueType, field: IssueRequiredField.CORRECTIVE_ACTIONS, onChange: handleChangeRequired }),
                            React.createElement(FieldSwitch, { issueType: rPopoverIssueType, field: IssueRequiredField.PREVENTATIVE_ACTIONS, onChange: handleChangeRequired }))))))));
        })));
}
export default AdvancedIssueTypesPage;
function FieldSwitch({ field, issueType, onChange }) {
    const { requirements = [] } = issueType;
    const isRequired = (requirements === null || requirements === void 0 ? void 0 : requirements.indexOf(field)) >= 0;
    const label = issueRequiredFieldLabel(field);
    const stateAfterChange = useMemo(() => (isRequired ? requirements.filter(v => v !== field) : [...requirements, field]), [field, requirements, isRequired]);
    const handleChange = useCallback(async () => {
        onChange(stateAfterChange);
    }, [onChange, stateAfterChange]);
    return (React.createElement(Pane, null,
        React.createElement(Switch, { checked: isRequired, onChange: handleChange, label: label })));
}
